export default __webpack_public_path__ + "static/media/queroTerceirizarMasNaoDefini.24de6901.svg";